export default "__VITE_ASSET__OkuBz$0h__"